import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session7 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans cette nouvelle séance et merci d’être là !</h3>
            <p>
              Aujourd’hui, nous allons parler de bénévolat et de volontariat :
              une manière de s’engager pour autrui et d’aider les autres.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1uFS4QzwJ-_iQbFoVtrxM9p5PotnjS3Sz5UqUY6vIv08"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                La solidarité est limitée au cercle familial :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="vrai"
                  control={<Radio />}
                  label="Vrai"
                />
                <FormControlLabel
                  value="faux"
                  control={<Radio />}
                  label="faux"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Des jeux de société, il y en a des milliers de sortes à travers le
              monde. As-tu déjà essayé d’expliquer les règles d’un jeu à un ami
              ou un membre de ta famille ?
            </p>
            <p>
              Aujourd’hui, tu vas découvrir un jeu que tu ne connais peut-être
              pas encore. L’objectif sera, sur les deux séances, de trouver
              comment expliquer les règles.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>La vidéo qui suit te montre un jeu qui s’appelle Ouisticlic.</p>
            <p>
              Ta mission du jour est de prendre des notes sur un papier pendant
              que tu regardes la vidéo pour bien comprendre toi-même les règles
              dans un premier temps.
            </p>
            <p>
              Tu peux regarder la vidéo autant de fois que nécessaire pour être
              à l’aise avec le jeu.
            </p>
            <iframe
              style={{display: 'block', margin: 'auto'}}
              width="560"
              height="315"
              src="https://www.youtube.com/embed/T3YStftWfhI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <p>
              Garde bien tes notes, tu en auras besoin pour la prochaine séance
              !
            </p>
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Dans le bénévolat, plus on est nombreux, plus nos actions ont un
                impact important !
              </p>
              <p>
                Ta mission sur les deux prochaines séances sera d’expliquer le
                bénévolat et l’action que tu mènes à un nouvel arrivant dans le
                groupe. Imagine qu’il ou elle ne connaît pas bien le thème
                choisi, et ne sait pas bien ce qu’est être bénévole… tu vas
                l’aider à décoder tout cela !
              </p>
              <p>Continuons !</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>
                La vidéo qui suit te montre un exemple d’explication des actions
                bénévoles. Ici, il s’agit de l’organisation UNICEF, une branche
                des Nations Unies qui protège les droits des enfants dans le
                monde.
              </p>
              <p>
                Tu peux prendre des notes sur un papier pendant que tu regardes
                la vidéo pour bien comprendre comment le bénévolat est expliqué.
              </p>
              <p>Tu peux regarder la vidéo autant de fois que nécessaire.</p>
              <iframe
                style={{display: 'block', margin: 'auto'}}
                width="560"
                height="315"
                src="https://www.youtube.com/embed/vrZ5hGfcV7c"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <p>
                Maintenant, note toutes les idées qui te viennent à l’esprit
                pour expliquer ton bénévolat à ce nouvel arrivant.
              </p>
              <p>
                Garde bien tes notes, tu en auras besoin pour la prochaine
                séance !
              </p>
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session7')
              .add({
                date: now,
                response: response,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session7;
